import { FRONTEND_URL, FRONTENDLMS_URL, FRONTMICROSITE } from '../../Redux/Paths';
const BASE_URL = 'https://www.litethinking.com';

export const getParamFromUrl = (id) => {
  const url = new URL(window.location.href);
  const queryParams = new URLSearchParams(url.search);
  return queryParams.get(id);
};

export const redirect = (url) => {
  window.location.href = url;
};

const redirectBlank = (url) => {
  // window.open(`${url}`, '_blank');
  const finalUrl = new URL(url, window.location.origin).toString();
  window.open(finalUrl, '_blank', 'noopener,noreferrer');
};

export const handleNavigation = (url, language) => {
  if (!url) return;
  let cleanUrl = url.replace('/out', '');
  let baseUrl;
  if (cleanUrl.includes('{language}')) {
    cleanUrl = cleanUrl.replace('{language}', language?.description?.toLowerCase());
  }

  if (cleanUrl.includes('{redirect')) {
    if (cleanUrl.includes('{redirect_lms}')) {
      baseUrl = FRONTENDLMS_URL;
      cleanUrl = cleanUrl.replace('{redirect_lms}', baseUrl);
    } else if (cleanUrl.includes('{redirect_payment}')) {
      baseUrl = FRONTMICROSITE;
      cleanUrl = cleanUrl.replace('{redirect_payment}', baseUrl);
    } else {
      baseUrl = FRONTEND_URL;
      cleanUrl = cleanUrl.replace('{redirect}', baseUrl);
    }

    redirectBlank(cleanUrl);
  } else if (cleanUrl.includes('/out')) {
    redirectBlank(cleanUrl);
  } else {
    redirect(cleanUrl);
  }
};

export function removeBaseURL(url) {
  return url.startsWith(BASE_URL) ? url.replace(BASE_URL, '') : url;
}
